<template lang="pug">
  .news-carousel
    Swiper.carousel(ref="carousel" :options="{ slidesPerView: 1, grabCursor: true }")
      SwiperSlide.slide
        .item
          img.img(src="/img/news-stub2.png?q=2")
          .post
            .created-at 24.10.2024 в 5:00
            .title Добро пожаловать в мир TeRoom!
            .text
              p Наша команда стремится сделать ваше взаимодействие с TeRoom максимально легким и приятным.
              p Мы собрали для вас все ключевые ресурсы, чтобы вы могли сосредоточиться <br> на главном — вашем успехе!
            Btn(round xs :to="{ name: 'news-list' }") Читать далее
</template>

<script>
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';

export default {
  name: 'NewsCarousel',
  components: { Swiper, SwiperSlide },
  data() {
    return {
      items: [],
    };
  },
  created() {
    this.$store.dispatch('tariff/fetchItems');
  },
  methods: {
    prev() {
      const swiper = this.$refs?.carousel?.$swiper;
      swiper.slideTo(swiper.activeIndex - 1);
    },
    next() {
      const swiper = this.$refs?.carousel?.$swiper;
      swiper.slideTo(swiper.activeIndex + 1);
    },
  },
};
</script>

<style lang="scss">

  .news-carousel {
    .slide {
      height: 100%;
    }

    .item {
      height: 100%;
      background: #D3EAFF;
      border-radius: 8px;
      position: relative;
      box-sizing: border-box;
      overflow: hidden;
      display: flex;
      flex-direction: column;
    }

    .img {
      border-radius: 8px;
      width: 100%;
      height: 184px;
      object-fit: cover;
    }

    .post {
      background: #FFFFFF;
      box-shadow: 0 6px 12px rgba(0, 0, 0, 0.08);
      border-radius: 8px;
      padding: 20px 25px 28px;
      margin: -24px 11px 11px;
      position: relative;
      z-index: 1;
      flex-grow: 1;
    }

    .created-at {
      font-weight: 400;
      font-size: 11px;
      line-height: 14px;
      letter-spacing: 0.02em;
      color: #788CA1;
      margin-bottom: 3px;
    }

    .title {
      font-weight: 500;
      font-size: 18px;
      line-height: 23px;
      letter-spacing: 0.01em;
      color: #1E3147;
      margin-bottom: 11px;
    }

    .text {
      font-weight: 400;
      font-size: 14px;
      line-height: 18px;
      letter-spacing: 0.02em;
      color: #788CA1;
      margin-bottom: 24px;
    }
  }

  // CSS Grid/Flexbox bug size workaround
  // @see https://github.com/kenwheeler/slick/issues/982
  // no scoped
  .news-carousel {
    display: grid;

    .swiper-container{
      height: 100%;
      max-height: 100vw;
      min-height: 0;
      min-width: 0;
      max-width: 100vw;
      width: 100%;
      overflow: hidden;
    }

    .swiper-slide{
      width: auto;
      flex-shrink: 0;
      display: block;
      height: 100%;
      max-height: 100%;
    }

    .swiper-wrapper{
      max-height: 100%;
      height: 100%;
      display: flex;
      min-height: 0;
      min-width: 0;
    }
  }
</style>
